import { render, staticRenderFns } from "./InternationalizationRating.vue?vue&type=template&id=6bf5a730"
import script from "./InternationalizationRating.vue?vue&type=script&lang=js"
export * from "./InternationalizationRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports